export default __webpack_public_path__ + "static/media/44.b6f9625e.jpg";